export const scheduleStatus = {
  PENDING: 'PENDENTE',
  SENT: 'ENVIADO',
  FAILED: 'FALHOU'
}
